import { RECEIVE_DATA_OBJECTS, REMOVE_DATA_OBJECTS, STORE_DATA_OBJECTS } from '@inpart-io/devtools-vue';
import { type IObligation, type IObligationInstance, type IObligationInstanceStatusPayload, obligationInstancesManager } from '@inpart-io/padme-iap';
import { type ActionTree } from 'vuex';

import { OBLIGATION_MODULE } from '@/store/obligation-module';

export const UPDATE_OBLIGATION_INSTANCE_STATUS = 'onUpdateObligationInstanceStatus';
export const DISCARD_DATA_OBJECT = 'discardDataObject';

export const actions: ActionTree<IObligationInstance, unknown> = {
    [DISCARD_DATA_OBJECT](context, { dobjId }: { dobjId: number }): void {
        context.commit(REMOVE_DATA_OBJECTS, { dobjId });
    },

    [STORE_DATA_OBJECTS](context, { dataObjectList }: { dataObjectList: IObligationInstance[] }) {
        const obligations: IObligation[] = [];
        const obligationInstances: IObligationInstance[] = [];

        dataObjectList.forEach((obligationInstance) => {
            let _obligationInstance = Object.assign({}, obligationInstance);

            if (obligationInstance.obligation !== null && obligationInstance.obligation !== undefined && typeof obligationInstance.obligation !== 'number') {
                const obligation: IObligation = Object.assign({}, obligationInstance.obligation);
                _obligationInstance = Object.assign({}, obligationInstance, { obligation: obligation.dobjId });
                obligations.push(obligation);
            }

            obligationInstances.push(_obligationInstance);
        });

        if (obligationInstances.length) {
            context.commit(RECEIVE_DATA_OBJECTS, { dataObjectList: obligationInstances });
        }
        if (obligations.length) {
            void context.dispatch(`${OBLIGATION_MODULE}/${STORE_DATA_OBJECTS}`, { dataObjectList: obligations }, { root: true });
        }
    },

    async [UPDATE_OBLIGATION_INSTANCE_STATUS](
        context,
        {
            obligationInstanceId,
            status,
            payload,
            properties
        }: { obligationInstanceId: number; status: string; payload: IObligationInstanceStatusPayload; properties?: string }
    ): Promise<IObligationInstance> {
        const result = await obligationInstancesManager.onUpdateStatusOfObligation(obligationInstanceId, status, payload, { properties });
        void context.dispatch(STORE_DATA_OBJECTS, { dataObjectList: result });
        return result?.[0];
    }
};
